import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import cx from "classnames"
import Button from '../../button/button'
import './styles.scss'

function MobileBottomNav({ language }) {
  const { allDataYaml: { edges } } = useStaticQuery(graphql`
    {
      allDataYaml {
        edges {
          node {
            mobilelp {
              application {
                navigate
              }
            }
            language
          }
        }
      }
    }
  `)

  const { node: { mobilelp: { application } } } = edges.find(({node}) => node.language === language)

  const [scrolledHeader, setScrolledHeader] = useState(true)
  useEffect(() => {
    const formElem = document.getElementById('mobile-application-form');

    window.addEventListener("scroll", event => {
      let scrollTop = document.documentElement.scrollTop

      if (scrollTop < formElem.offsetTop - window.innerHeight) {
        setScrolledHeader(true)
      } else {
        setScrolledHeader(false)
      }
    })
  }, [])

  return <div className={cx("mobile-bottom-nav bg-100", {"active": scrolledHeader})}>
    <Button className="header-application-button" color="purple" size="lg" text={application.navigate} link="#mobile-application-form" />
  </div>
}

export default MobileBottomNav
